/**
 * This is to be copied from the etc/config.js in the production environment
 */

export const PortalConfig = {
	APIUrl: "/api.php/",
	language: "en",
	frontendUrl: "/",
	//sectionId: 1, //Sets a fixed section for this frontend
	//singleCertificateSectionId: 1 //Will print only a single certificate button that uses this section ID. The certificate should print all sections if this is used. (FrieslandCampina)
	title: 'Fresenius E-learning',
	participant: {
		requireEmail: true,
		requireCompany: true,
		skipEmailForSection: true
	}
} as const;
